import { getBackendBaseUrl } from './config';
import { getAuthHeaders } from './auth';

export interface ProjectAnalysisProfile {
  id: number;
  name: string;
  username: string;
  email: string;
  mobile: string | null;
  mobile_national?: string | null;
}

function getApiBase(): string {
  const base = getBackendBaseUrl();
  return base ? `${base}/api` : '/api';
}

async function parseJson(r: Response): Promise<unknown> {
  const t = await r.text();
  if (!t?.trim()) return {};
  try {
    return JSON.parse(t) as unknown;
  } catch {
    return {};
  }
}

function pickMessage(json: unknown, fallback: string): string {
  if (!json || typeof json !== 'object') return fallback;
  const j = json as Record<string, unknown>;
  if (typeof j.message === 'string' && j.message.trim()) return j.message;
  return fallback;
}

export const projectAnalysisProfileApi = {
  async fetch(): Promise<ProjectAnalysisProfile> {
    const r = await fetch(`${getApiBase()}/task-manager/me`, {
      headers: getAuthHeaders(),
    });
    const json = await parseJson(r);
    const data = (json as { data?: ProjectAnalysisProfile }).data;
    if (!r.ok || !data) throw new Error(pickMessage(json, `خطا: ${r.status}`));
    return data;
  },
};
